import { Button, ColorPicker, Divider } from "@arco-design/web-react";

export const PresetColorPicker = (props) => {
    const { onChange } = props;

    return (
        <ColorPicker
            {...props}
            size="mini"
            showPreset
            renderFooter={() => <>
                <Divider style={{ marginTop: 0, marginBottom: 0 }} />
                <Button
                    style={{ margin: 5 }}
                    size="mini"
                    onClick={() => {
                        onChange && onChange("transparent");
                    }} >Clear</Button>
            </>}
        />
    )
}
